import { universalApolloClient } from '../helpers/api';
import gql from 'graphql-tag';

export async function getFavorites(orgId, userId) {
  const resp = await universalApolloClient.query({
    fetchPolicy: 'no-cache',
    variables: {
      input: {
        orgId,
        userId,
      }
    },
    query: gql`
      query getNavFavorites(
        $input: GetNavFavoritesInput!
        $resource: Resource = home
      ) {
        getNavFavorites(input: $input, resource: $resource) {
          hasFavorites
          favorites
        }
      }
    `,
  });
  return resp?.data?.getNavFavorites?.favorites || [];
}

export async function setFavorites(orgId, userId, favorites) {
  const resp = await universalApolloClient.mutate({
    variables: {
      input: {
        orgId,
        userId,
        favorites,
      }
    },
    mutation: gql`
      mutation setNavFavorites(
        $input: SetNavFavoritesInput!
        $resource: Resource = home
      ) {
        setNavFavorites(input: $input, resource: $resource) {
          favorites
        }
      }
    `,
  });
  return resp?.data?.setNavFavorites?.favorites || [];
}